<template>
  <div
    class="grid-scroll"
    :style="scrollStyle"
  >
    <v-row
      no-gutters
    >
      <v-col
        v-for="(item, i) in mergedItems"
        :key="item.src + '_' + i"
        class="grid-cell"
      >
        <v-tooltip
          bottom
        >
          <template
            #activator="{ on }"
          >
            <v-btn
              icon
              :class="{ activeBTN: activeKey === item.src }"
              v-on="on"
              @click="$emit('select', item)"
            >
              <img
                class="icono"
                :src="item.img"
                :height="iconSize"
                :width="iconSize"
                :alt="item.label"
              >
            </v-btn>
          </template>
          <span>{{ item.label }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'SymbologyIconGrid',
  props: {
    lists: { type: Array, required: true },
    activeKey: { type: [String], default: null },
    basePath: { type: String, default: '' },
    iconSize: { type: [Number], default: 35 },
    maxHeight: { type: [Number], default: 168 }
  },

  computed: {
    mergedItems() {
      return this.lists.flat().filter(Boolean)
    },
    scrollStyle() {
      const mh = `${this.maxHeight}px`
      return { maxHeight: mh }
    }
  }
}
</script>

<style scoped>
.grid-scroll {
  overflow-y: auto;
  padding: 4px 0;
}

.activeBTN {
  border: 2px solid rgb(255, 255, 255);
}

.icono {
  object-fit: contain;
  display: block;
  margin: auto;
  padding: 3px;
}

.grid-cell {
  flex: 0 0 auto;
  width: 10%; /* 6 por fila */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
</style>
